import React from 'react';
import { useTranslation } from 'react-i18next';
import {Check} from 'lucide-react';
import {APP_NAME} from '../utils/constants';

const Subscription = () => {
    const { t } = useTranslation();
    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({behavior: 'smooth'});
        }
    };
    return (
        <section id="subscription" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">
                    {t('subscription.title', { appName: APP_NAME })}
                </h2>


                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 p-8">
                    <Plan
                        title="subscription.plans.starter.title"
                        price="49€"
                        subtitle="subscription.plans.common.perMonth"
                        features={[
                            "subscription.plans.starter.features.meals",
                            "subscription.plans.starter.features.sauces",
                            "subscription.plans.starter.features.card",
                            "subscription.plans.starter.features.access",
                            "subscription.plans.starter.features.queue"
                        ]}
                        highlight={false}
                        scrollToSection={scrollToSection}
                    />

                    <Plan
                        title="subscription.plans.base.title"
                        price="149€"
                        subtitle="subscription.plans.common.perMonth"
                        features={[
                            "subscription.plans.base.features.meals",
                            "subscription.plans.base.features.sauces",
                            "subscription.plans.base.features.card",
                            "subscription.plans.base.features.drinks",
                            "subscription.plans.base.features.management"
                        ]}
                        highlight={true}
                        badge="subscription.plans.base.mostPopular"
                        scrollToSection={scrollToSection}
                    />

                    <Plan
                        title="subscription.plans.premium.title"
                        price="299€"
                        subtitle="subscription.plans.common.perMonth"
                        features={[
                            "subscription.plans.premium.features.meals",
                            "subscription.plans.premium.features.sauces",
                            "subscription.plans.premium.features.card",
                            "subscription.plans.premium.features.drinks",
                            "subscription.plans.premium.features.discount"
                        ]}
                        highlight={false}
                        scrollToSection={scrollToSection}
                    />
                </div>
            </div>
        </section>
    );
};

const Plan = ({title, price, subtitle, features, highlight, badge, scrollToSection}) => {
    const { t } = useTranslation();
    return (
        <div
            className={`relative rounded-2xl shadow-lg p-10 flex flex-col items-center justify-between ${highlight ? 'bg-white border-4 border-pastita-orange scale-105 z-10' : 'bg-white'}`}>
            {badge && (
                <div className="absolute -top-4 bg-pastita-orange text-white text-sm font-bold px-4 py-1 rounded-full">
                    {t(badge)}
                </div>
            )}
            <div className="mb-8">
                <h3 className="text-2xl font-bold text-pastita-dark mb-2">{t(title)}</h3>
                <div className="text-5xl font-extrabold text-pastita-orange mb-1">{price}</div>
                <p className="text-md text-gray-600">{t(subtitle)}</p>
            </div>

            <div className="text-left space-y-4 mb-8">
                {features.map((f, i) => (
                    <div key={i} className="flex items-center space-x-3">
                        <Check className="w-5 h-5 text-pastita-orange"/>
                        <span className="text-pastita-dark">{t(f)}</span>
                    </div>
                ))}
            </div>

            <button
                onClick={() => scrollToSection('contact')}
                className="px-6 py-3 rounded-full text-white bg-pastita-orange hover:bg-pastita-dark transition font-semibold">
                {t('subscription.contactButton')}
            </button>
        </div>
    );
};

export default Subscription;
